import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { profileService, type UserProfile } from "@/services/profile.service";

/**
 * Hook to fetch and cache user profile data
 * Uses React Query for automatic caching and refetching
 */
export const useProfile = () => {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ["profile"],
    enabled: isAuthenticated,
    queryFn: async (): Promise<UserProfile> => {
      return await profileService.getProfile();
    },
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    retry: 2, // Retry failed requests twice
    retryDelay: 1000, // Wait 1 second between retries
  });
};
